import { isNumber } from '.'
import ExclamationCircleIconMini from '../components/heroicons/mini/ExclamationCircleIcon'
import HandThumbDownIcon from '../components/heroicons/mini/HandThumbDownIcon'
import HandThumbUpIcon from '../components/heroicons/mini/HandThumbUpIcon'
import CheckCircleIcon from '../components/heroicons/solid/CheckCircleIcon'
import ExclamationCircleIconSolid from '../components/heroicons/solid/ExclamationCircleIcon'
import XCircleIcon from '../components/heroicons/solid/XCircleIcon'
import { colors } from '../constants'

const high_fit = {
  dark: colors.darkGreen,
  medium: colors.mediumGreen,
  light: colors.lightGreen
}

const medium_fit = {
  dark: colors.darkYellow,
  medium: colors.mediumYellow,
  light: colors.lightYellow
}

const low_fit = {
  dark: colors.darkRed,
  medium: colors.mediumRed,
  light: colors.lightRed
}

export const getColors = ({ score, score_key, fit }) => {
  // be aware of the order
  if (score_key) {
    return {
      green: high_fit,
      'score>50': high_fit,
      'yellow&score>50': medium_fit,
      'yellow&score<=50': medium_fit,
      red: low_fit,
      'score<=50': low_fit
    }[score_key]
  }

  if (isNumber(score)) {
    if (score >= 70) return high_fit
    else if (score > 30 && score < 70) return medium_fit
    // score <= 30
    else return low_fit
  }

  if (isNumber(fit)) {
    // dimension_match is continuous (0 to 1) for RIASEC from scoring revision 2, else 0 / 0.5 / 1.
    // Same bands as the backend (MATCHINGPROFILE): >= 0.7 high, > 0.3 medium, else low.
    if (fit >= 0.7) return high_fit
    else if (fit > 0.3) return medium_fit
    else return low_fit
  }
}

export const getIconOverallReview = ({ score, score_key }) => {
  // be aware of the order
  if (score_key) {
    return {
      green: HandThumbUpIcon,
      'score>50': HandThumbUpIcon,
      'yellow&score>50': ExclamationCircleIconMini,
      'yellow&score<=50': ExclamationCircleIconMini,
      red: HandThumbDownIcon,
      'score<=50': HandThumbDownIcon
    }[score_key]
  }

  if (score >= 70) return HandThumbUpIcon
  else if (score > 30 && score < 70) return ExclamationCircleIconMini
  // score <= 30
  else return HandThumbDownIcon
}

export const getIconDimensionFit = ({ fit, score }) => {
  if (isNumber(fit)) {
    // same bands as getColors
    if (fit >= 0.7) return CheckCircleIcon
    else if (fit > 0.3) return ExclamationCircleIconSolid
    else return XCircleIcon
  }

  if (isNumber(score)) {
    if (score >= 70) return CheckCircleIcon
    else if (score > 30 && score < 70) return ExclamationCircleIconSolid
    // score <= 30
    else return XCircleIcon
  }
}

export const blueTones = {
  0: colors.darkBlue,
  1: colors.primaryBlue,
  2: colors.brightBlue,
  3: colors.lightBlue,
  4: colors.paleBlue,
  5: colors.paleWhiteBlue
}
